import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=a30d26f8&scoped=true&"
import script from "./AboutView.vue?vue&type=script&lang=js&"
export * from "./AboutView.vue?vue&type=script&lang=js&"
import style0 from "./AboutView.vue?vue&type=style&index=0&id=a30d26f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30d26f8",
  null
  
)

export default component.exports